import axios from 'axios'
import store from "@/store";
import moment from 'moment'

export default {
    state: {
        trainerMessageRequests: [],
        trainerMessages: [],
        userMessages: [],
        chatOut: [],
        chatFromTo: [],
        trainerRequestStatus: [],
        chatEnd: [],
        chatReopen: [],
        trainerPlaylist: [],
        trainerPlaylistSong: [],
        trainerFavoriteSong: [],
        trainerPlaylistEdit: [],
        favoriteList: [],
    },

    getters: {
        trainerPlaylistEdit(state) {
            return state.trainerPlaylistEdit
        },
        trainerPlaylistSong(state) {
            return state.trainerPlaylistSong
        },
        trainerFavoriteSong(state){
            return state.trainerFavoriteSong
        },
        trainerPlaylist(state) {
            return state.trainerPlaylist
        },
        chatEnd(state) {
            return state.chatEnd
        },
        chatReopen(state) {
            return state.chatReopen
        },
        trainerRequestStatus(state) {
            return state.trainerRequestStatus
        },
        chatFromTo(state) {
            return state.chatFromTo
        },
        trainerMessageRequests(state) {
            return state.trainerMessageRequests
        },
        trainerMessages(state) {
            return state.trainerMessages
        },
        userMessages(state) {
            return state.userMessages
        },
        chatOut(state) {
            return state.chatOut
        },
        favoriteList(state){
            return state.favoriteList
        }
    },

    actions: {
        async getUpdateFavoriteList({commit}, data) {
            commit('setUpdateFavoriteList', data)
        },
        async getTrainerMessageRequest({ commit }) {
            const res = await axios.get('trainer/message/request')

            const data = res.data
            commit('setTainerRequestMessages', data)
        },
        async getTrainerMessages({ commit }, { payload = {} }) {
            const res = await axios.post('trainer/messages', payload)

            const data = res.data
            commit('setTainerMessages', data)
        },
        async getUserMessages({ commit }, { payload = {} }) {
            const res = await axios.post('user/messages', payload)

            const data = res.data
            commit('setUserMessages', data)
        },
        async getEarlierChatMsgs({ commit }, { query, data }) {
            try {
                if (!query.page) {
                    query.page = 1;
                }
                const res = await axios.get(`/chat/${data.chat_id}?page=` + query.page)
                let profile = res.data.data.profile;
                delete res.data.data.profile;
                res.data['profile'] = profile;
                let newData = res.data;
                let i = 0;
                let j = Object.keys(newData.data).length - 1;
                let arr = [];
                while (j >= 0) {
                    arr[i] = newData.data[j];
                    i++;
                    j--;
                }
                newData.data = arr;
                commit('setChatEarlierData', newData)
            }catch (err) {
                commit('setError', {title: "Alert", text: err})
                throw err
            }
        },
        async getChatFromTo({ commit }, { query, data }) {
            if (!query.page) {
                query.page = 1;
            }
            const res = await axios.get(`/chat/${data.chat_id}?page=` + query.page)
            let profile = res.data.data.profile;
            delete res.data.data.profile;
            res.data['profile'] = profile;
            let newData = res.data;
            let i = 0;
            let j = Object.keys(newData.data).length - 1;
            let arr = [];
            while (j >= 0) {
                arr[i] = newData.data[j];
                i++;
                j--;
            }
            newData.data = arr;
            commit('setChatFromTo', newData)
        },

        async getRequestPendingMessages({ commit }, data) {
            const res = await axios.get(`/request/pending/messages/${data.from}/${data.to}`)
            let profile = res.data.data.profile;
            delete res.data.data.profile;
            res.data['profile'] = profile;
            let newData = res.data;
            let i = 0;
            let j = Object.keys(newData.data).length - 1;
            let arr = [];
            while (j >= 0) {
                arr[i] = newData.data[j];
                i++;
                j--;
            }
            newData.data = arr;
            commit('setChatFromTo', newData)
        },

        async chatOut({ commit }, data) {
            try {
                const res = await axios.post('chat/out', data)
                const newData = res.data.data
                commit('setChatOut', newData)
            }catch(err) {
                commit('setError', {title: "Alert", text: err})
                throw err
            } 
        },

        async chatEnd({ commit }, data) {
            try {
                const res = await axios.post('chat/end', data)
                const newData = res.data.data
                commit('setChatEnd', newData)
            }catch (err) {
                commit('setError', {title: "Alert", text: err})
                throw err
            }
        },

        async postChatReopen({ commit }, payload) {
            try {
                const res = await axios.post('chat/reopen', payload)
                const data = res.data.data
                commit('setChatReopen', data)
            }catch (err) {
                commit('setError', {title: "Alert", text: err})
                throw err
            }
        },

        async trainerRequestStatus({ commit }, data) {
            try {
                const res = await axios.post('trainer/request/status', data)

                const newData = res.data
                commit('setTrainerRequestStatus', newData)
            } catch (e) {
                commit('setIsLoading', false)
                throw e;
            }
        },

        async postTrainerPlaylist({ commit }, data) {
            const res = await axios.post('trainer/playlist', data)

            store.commit("setIsSuccess", res && res.data && res.data.message);
            const newData = res.data && res.data.data
            commit('setPostTrainerPlaylist', newData)
        },

        async postTrainerPlaylistSong({ commit }, data) {
            const res = await axios.post(`trainer/playlist/${data.playlist_id}/song`, data)

            store.commit("setIsSuccess", res && res.data && res.data.message);
            const newData = res.data && res.data.data
            commit('setTrainerPlaylistSong', newData)
        },
        async postTrainerFavoriteSong({ commit }, data) {
            const res = await axios.post(`trainer/add-remove-favourite-song`, data)

            store.commit("setIsSuccess", res && res.data && res.data.message);
            const newData = res.data && res.data.data;
            commit('setTrainerFavoriteSong', newData)
        },        

        async getTrainerPlaylist({ commit }) {
            const res = await axios.get(`trainer/playlist`)

            const data = res.data && res.data.data
            commit('setTrainerPlaylist', data)
        },

        async getTrainerPlaylistEdit({ commit }, id) {
            const res = await axios.get(`trainer/playlist/${id}/edit`)

            const data = res.data && res.data.data
            commit('setTrainerPlaylistEdit', data)
        },

        async getTrainerPlaylistSong({ commit }, id) {
            const res = await axios.get(`trainer/playlist/${id}/song`)

            const data = res.data && res.data.data
            commit('setTrainerPlaylistSong', data)
        },
        async getTrainerFavoriteSong({ commit },id) {
            var url = null;
            if (id === 1) {
              url = "trainer/favourite-song";
            } else {
              url = "trainer/favourite-song?page=" + id;
            }

            const res = await axios.get(url);
            const data = res.data;
            commit('setTrainerFavoriteSong', data)
        },        

        async deleteTrainerPlaylistSong({ commit }, data) {
            const res = await axios.delete(`trainer/playlist/${data.id}/song/${data.song_id}`, data)

            store.commit("setIsSuccess", res && res.data && res.data.message);
            const newData = res.data && res.data.data
            commit('delTrainerPlaylistSong', newData)
        },

        async deleteTrainerPlaylist({ commit }, data) {
            const res = await axios.delete(`trainer/playlist/${data.id}`, data)

            store.commit("setIsSuccess", res && res.data && res.data.message);
            const newData = res.data
            commit('delTrainerPlaylist', newData)
        },

        async updateTrainerPlaylist({ commit }, { id, data }) {
            const res = await axios.post(`trainer/playlist/${id}?_method=PUT`, data)

            store.commit("setIsSuccess", res && res.data && res.data.message);
            const newData = res.data
            // commit('setTrainerPlaylist', newData)
        },

        async putTrainerPlaylistSong({ commit }, data) {
            const res = await axios.put(`trainer/playlist/${data.id}/song/${data.song_id}`, data)

            store.commit("setIsSuccess", res && res.data && res.data.message);
            const newData = res.data
            // commit('setTrainerPlaylistSong', newData)
        },
    },

    mutations: {
        setUpdateFavoriteList(state, data){
            state.favoriteList = data;
        },
        setTrainerPlaylistSong(state, data) {
            state.trainerPlaylistSong = data
        },
        setTrainerFavoriteSong(state, data) {
            state.trainerFavoriteSong = data;
        },
        delTrainerPlaylistSong(state, data) {
            state.trainerPlaylistSong = state.trainerPlaylistSong.filter((song) => song.id !== data.id);
        },
        delTrainerPlaylist(state, data) {
            state.trainerPlaylist = state.trainerPlaylistSong.filter((playlist) => playlist.id !== data.id);
        },
        setPostTrainerPlaylist(state, data) {
            state.trainerPlaylist.push(data)
        },
        setTrainerPlaylist(state, data) {
            state.trainerPlaylist = data
        },
        setTrainerPlaylistEdit(state, data) {
            state.trainerPlaylistEdit = data
        },
        setChatEnd(state, data) {
            state.chatEnd = data
        },
        setChatReopen(state, data) {
            state.chatReopen = data
        },
        setChatFromTo(state, data) {
            state.chatFromTo = data
        },
        setChatEarlierData(state, response) {
            response.data = [...response.data, ...state.chatFromTo.data]
            state.chatFromTo = response
        },
        setMessageSent(state, data) {
            state.chatFromTo.data.push(data)
        },
        setChatOut(state, data) {
            let date = new Date(data.created_at);
            let localOffset = date.getTimezoneOffset() * 60000;
            let localTime = date.getTime();
            date = localTime + localOffset;
            data.created_at = moment(new Date(date)).format("MMM D, YYYY h:mm A");
            state.chatFromTo.data.pop();
            state.chatFromTo.data.push(data)
        },
        setTainerRequestMessages(state, data) {
            state.trainerMessageRequests = data
        },
        setTrainerRequestStatus(state, data) {
            state.trainerMessages = data
        },
        setTainerMessages(state, data) {
            state.trainerMessages = data
        },
        setUserMessages(state, data) {
            state.userMessages = data
        }
    }
}